import { FancyToggle } from 'apps/builder/components/settings/modal'
import { selectStyles, BasicTooltip } from 'apps/builder/components/shared'
import { useDispatch } from 'react-redux'
import { updateEntry } from 'apps/builder/store/actions/entries'
import {
  RequiredToggle,
  SettingsFieldSelect,
} from 'apps/builder/components/settings/modal/shared'
import Select from 'react-select'
import { useEffect, useState } from 'react'

const gpsDisplayOptions = [
  {
    label: 'Small Map',
    value: 0,
  },
  {
    label: 'Large Map',
    value: 1,
  },
  {
    label: 'Lat/Long',
    value: 2,
  },
  {
    label: 'Map Link',
    value: 3,
  },
]

const zoomOptions = [
  {
    label: 'Farthest (State)',
    value: 0,
  },
  {
    label: 'Farther',
    value: 1,
  },
  {
    label: 'Far',
    value: 2,
  },
  {
    label: 'Middle (City)',
    value: 3,
  },
  {
    label: 'Close',
    value: 4,
  },
  {
    label: 'Closer (Street)',
    value: 5,
  },
  {
    label: 'Closest',
    value: 6,
  },
]

const getGpsValue = gpsValue =>
  gpsDisplayOptions.find(({ value }) => value == gpsValue)
const getZoomValue = zoomValue =>
  zoomOptions.find(({ value }) => value == zoomValue)

export const GPSField = ({
  guid,
  required,
  visible,
  gps_display_type = 0,
  type,
  label,
  keyField,
  zoom_level = 4,
}) => {
  const dispatch = useDispatch()
  const [requiredDisabled, setRequiredDisabled] = useState(!visible)

  useEffect(() => {
    setRequiredDisabled(!visible)
  }, [visible])

  return (
    <>
      <div className="settings--row">
        <SettingsFieldSelect
          guid={guid}
          label={label}
          keyField={keyField}
          type={type}
        />

        <div className="toggles-group">
          <div className="toggle-wrapper">
            <RequiredToggle
              guid={guid}
              active={required}
              disabled={requiredDisabled}
            />
          </div>

          <div className="toggle-wrapper">
            <FancyToggle
              label="Hidden"
              id={guid}
              active={!visible}
              inlineBorderTooltipStyle={true}
              onChange={checked => {
                dispatch(
                  updateEntry({
                    guid,
                    visible: !checked,
                    required: checked,
                  })
                )
                checked ? setRequiredDisabled(false) : setRequiredDisabled(true)
              }}
              tooltip="Hidden fields are not visible to the person filling out the app.
                  Useful for automatically capturing things like GPS location, date, and time."
              tooltipDirection="bottom"
            />
          </div>
        </div>
      </div>

      <div className="settings--gps">
        <Select
          styles={selectStyles}
          className="input--placeholder"
          classNamePrefix="react-select"
          options={gpsDisplayOptions}
          value={getGpsValue(gps_display_type)}
          onChange={({ value }) => {
            dispatch(
              updateEntry({
                guid,
                gps_display_type: value,
              })
            )
          }}
        />
        <label>Display on PDF and Web</label>
      </div>

      <div className="settings--gps">
        <Select
          styles={selectStyles}
          isDisabled={gps_display_type > 1}
          className="input--placeholder"
          options={zoomOptions}
          value={getZoomValue(zoom_level)}
          onChange={({ value }) => {
            dispatch(
              updateEntry({
                guid,
                zoom_level: value,
              })
            )
          }}
        />
        <label>Map Zoom</label>
      </div>
    </>
  )
}
